import PropTypes from 'prop-types';

import AcademyTopicResourceType from './academyTopicResourceType';
import SuperBatchResourceType from './superBatchResourceType';

const SbatGroupResourceType = PropTypes.shape({
  date_of_topic: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  academy_topic: AcademyTopicResourceType,
  super_batch_academy_topics: PropTypes.arrayOf(SuperBatchResourceType),
});

export default SbatGroupResourceType;
